import React, { useEffect, useState } from "react";
import Checkout from "./Checkout";
import Preheader from "../KalHome/Preheader";
import Header from "../KalHome/Header";
import Footer from "../Homecomponents/Footer";
import Endfooter from "../Homecomponents/Endfooter";
import Superheader from "../KalHome/Superheader";

const MainCheckout = () => {
    const [isSticky, setIsSticky] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsSticky(window.scrollY > 50); // Adjust threshold as needed
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  return (
    <>
      {/* <Preheader /> */}
      <Superheader />
      <div className={isSticky ? "header-wrapper sticky" : "header-wrapper"}>
        <Header />
      </div>
      <Checkout isSticky={isSticky}/>
      <Footer />
      <Endfooter />
    </>
  );
};

export default MainCheckout;
